import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

import { useSettings } from 'app/main/components';
import { QuantitySelectCellTooltip } from './QuantitySelectCell';

interface QuantitySelectFieldProps {
	quantities: number[];
	value?: number;
	pricingLots?: any[];
	discountPercentage?: number;
	handleChange: (name: any, newValue: any) => void;
}

function QuantitySelectField({
	quantities,
	value,
	pricingLots,
	discountPercentage,
	handleChange
}: QuantitySelectFieldProps) {
	const { t } = useSettings();

	const [openQuantitySelect, setOpenQuantitySelect] = React.useState(false);

	return (
		<QuantitySelectCellTooltip
			open={openQuantitySelect}
			pricingLots={pricingLots || []}
			discountPercentage={discountPercentage}
		>
			<FormControl variant="filled" fullWidth>
				<InputLabel id="quantity-select-label">
					<Typography variant="subtitle2">{t('DETAILS_ORDERS_LINES_FIELD_QUANTITY')}</Typography>
				</InputLabel>
				<Select
					name="orli_quantity"
					labelId="quantity-select-label"
					variant="filled"
					value={value}
					onChange={event => handleChange('orli_quantity', event.target.value)}
					open={openQuantitySelect}
					onOpen={() => setOpenQuantitySelect(true)}
					onClose={() => setOpenQuantitySelect(false)}
				>
					{quantities.map(quantity => (
						<MenuItem key={quantity} value={quantity}>
							{quantity}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</QuantitySelectCellTooltip>
	);
}

export default React.memo(QuantitySelectField);
